import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useFuelTypeQuery } from "@/hook/Dictionaries/useFuelTypeQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { FUEL_LIMITS_KEY } from "@/types/IFuelLimit"
import { FilterField, FilterFieldType, IFilterSelectField } from "@/types/ui"

export const useFuelLimitsFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: FUEL_LIMITS_KEY
  })

  const oldFilters: FieldData[] = getFilter()
  const { data: fuelTypes } = useFuelTypeQuery()

  useEffect(() => {
    var fultTypeFilter = FuelLimitsFilters.find(x=>x.name == "fuelTypeId") as IFilterSelectField
    fultTypeFilter.values =  fuelTypes?.response.data.map((f) => ({
      id: f.id,
      name: f.name
    })) ?? []
    setFilters(FuelLimitsFilters)
  })

  return mapFilters(filters, oldFilters)
}

const FuelLimitsFilters: FilterField[] = [
  {
    text: "Нефтебаза",
    name: "depot",
    type: FilterFieldType.Select,
    hidden: true
  },
  {
    text: "Начало периода",
    name: "startDate",
    type: FilterFieldType.DateRange
  },
  {
    text: "Конец периода",
    name: "endDate",
    type: FilterFieldType.DateRange
  },
  {
    text: "Лимит",
    name: "limit",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "Тип топлива",
    name: "fuelTypeId",
    type: FilterFieldType.Select
  }
]